import styled from 'styled-components';

export const Content = styled.div`
  .description {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: center;
  }

  .select {
    background: var(--color-page);
    height: 40px;
  }

  .footer-description {
    font-size: 12px;
    font-weight: 400;
    line-height: 15.6px;
    text-align: left;
  }

  .buttonGroup {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
    margin-top: 20px;

    button {
      width: 130px;
    }
  }
`;
